<template>
  <div class="project" v-if="currentOffer">
    <section class="section text-center">
      <h1>{{ currentOffer.project.title }}</h1>
      <p 
      v-html="currentOffer.project.description"
      class="mx-auto"
      style="max-width:800px">
      </p>
      <br/>
      <v-btn class="mx-auto px-10" rounded depressed color="#ef6758" style="color:white" x-large :to="{path: `/mon-projet/${currentOffer.iso}/questionnaire`}">
        {{ currentOffer.project.moreAction }}
      </v-btn>
    </section>
    <section class="section">
      <v-container 
      class="d-flex justify-space-between"
      :class="$vuetify.breakpoint.smAndDown ? 'flex-column': ''">
        
        <div class="one-card" :style="{width: $vuetify.breakpoint.smAndDown ? '100%' : '40%' }">
          <h2>Maintenant</h2>
          <p v-html="currentOffer.project.now "></p>
        </div>

        <div 
        class="d-flex align-center justify-center one-arrow">
          <v-icon size="60" color="#ef6758">mdi-arrow-right</v-icon>
        </div>

        <div class="one-card" :style="{width: $vuetify.breakpoint.smAndDown ? '100%' : '40%' }">
          <h2>Après</h2>
          <p v-html="currentOffer.project.after "></p>
        </div>

      </v-container>
    </section>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  methods: {
    ...mapActions('strapiv2', ['setCurrentOffer'])
  },
  computed: {
    ...mapGetters('strapiv2', ['currentOffer'])
  },
  mounted () {
    const iso = this.$route.params.iso
    this.setCurrentOffer(iso)
  }
}
</script>

<style scoped>
.project {
}

.project p {
  font-size: 21px;
  font-weight: 300;
}

.project h2 {
  padding-bottom: 0.2em!important;
  text-align: left;
  color:var(--btn-primary-color);
  font-size: 1.8em;
}
.one-card {
  border: 1px solid black;
  border-radius: 30px;
  padding: 1em;
  margin: 1em 0;
  
}
.one-arrow {
  color:var(--btn-primary-color);
}
</style>